import { Component, OnInit } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'app-print-invoice-normal',
  templateUrl: './print-invoice-normal.component.html',
  styleUrls: ['./print-invoice-normal.component.scss']
})
export class PrintInvoiceNormalComponent implements OnInit {
  invoice_id='';
  customer_id='';
  customer_name='';
  place_description='';
  place_address='';
  place_id='';
  fee_id='';
  fee_description='';
  due_datetime='';
  price='';
  total_price='';
  discount='';
  user='';

  isLoading=true;
  constructor(private route:ActivatedRoute,router:Router,private service:MyserviceService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => 
    {
      debugger
      this.invoice_id= params['invoice_id'];
   });
   
   this.refresh();
  }

  refresh()
  {
    this.isLoading=true;
    this.service.postData({invoice_id:this.invoice_id, topic: 'inv'},"invoice/get-invoice-detail").then((result:any)=>
    {
      debugger
      this.isLoading=false;
      console.log(result.data);
      if (!result.code) 
      {
        if (result.data.length > 0) 
        {
          this.customer_id=result.data[0].customer_id;
          this.customer_name=result.data[0].customer_name;
          this.place_id=result.data[0].place_id;
          this.place_address=result.data[0].place_address;
          this.place_description=result.data[0].place_description;
          this.fee_id=result.data[0].fee_id;
          this.fee_description=result.data[0].fee_description + ' จำนวน ' + result.data[0].fee_type_price + ' ' + result.data[0].fee_type_unit;
          this.due_datetime=moment(result.data[0].due_date).format("DD/MM/YYYY");
          this.invoice_id=result.data[0].invoice_id;
          this.price=result.data[0].total_price;
          this.total_price=result.data[0].total_price;
          
          this.service.postData({user_id:result.data[0].user_id},"user-location/get-user-detail").then((result2:any)=>
          {
            if (!result2.code) 
            {
              if (result2.data.length > 0) 
              {
                this.user=result2.data[0].user_name;
                setTimeout(() => {
                  window.print();
                }, 1000);
              }else
              {
                this.user=result2.data[0].user_id;
                setTimeout(() => {
                  window.print();
                }, 1000);
              }
            }
            else 
            {
              Swal.fire({
                title: result.message,
                text: '',
                type: 'error',
                showCancelButton: false,
                showConfirmButton: false,
                timer:2000
              });
            }
            
          })
          
        }
        
      }
      else 
      {
        Swal.fire({
          title: result.message,
          text: '',
          type: 'error',
          showCancelButton: false,
          showConfirmButton: false,
          timer:2000
        })
      }
      
    })
  }
}  
  

